'use strict';

const UP = 'up';
const DOWN = 'down';

function Fitter(initialValue, maxIterations) {
    this.initialValue = initialValue || 0.5;
    this.maxIterations = maxIterations;
    this.setValue(this.initialValue);
}

Fitter.prototype.maxDigits = 15;
Fitter.prototype.allowGreaterThanOne = false;
Fitter.prototype.numDuplicateSets = 0;

Fitter.prototype.log = function (what) {
    //console.log(what);
};

Fitter.prototype.setValue = function (val) {
    if (this.digit) {
        val = Math.floor(val * Math.pow(10, this.digit)) / Math.pow(10, this.digit);
    }
    if (this.value === val) {
        this.numDuplicateSets++;
    } else {
        this.numDuplicateSets = 0;
    }
    this.log(`Setting val to ${val} (${this.numDuplicateSets}-th time) (current digits ${this.digit})`);
    this.value = val;
    this.stringValue = val + '';
    if (!(/\./.test(this.stringValue))) {
        this.stringValue = `${this.stringValue}.0`;
    }
    const indexOfDot = this.stringValue.indexOf('.');
    let consecutiveZeroes = 0;
    for (let i = indexOfDot + 1; i < indexOfDot + this.maxDigits; i++) {
        let digit = this.stringValue[i];
        if (digit === void 0 || digit === '0') {
            consecutiveZeroes += 1;
            if (consecutiveZeroes >= 3) {
                this.digits = i - 3 - indexOfDot;
                break;
            }
        } else {
            this.digits = i - indexOfDot;
        }
    }
    if (this.digit === void 0) {
        this.digit = this.digits + 1;
    }
};

Fitter.prototype.getDigit = function (digit) {
    return Math.floor(Math.pow(10, digit) * this.value) % 10;
};

Fitter.prototype.plus = function () {
    if (this.direction === DOWN) {
        this.log('- -> +');
        this.digit = this.digit + 1;
    }
    let addend = Math.pow(10, -1 * this.digit);
    if (this.numDuplicateSets > 1) {
        addend *= 2;
    }
    this.log(`+${addend}`);
    this.direction = UP;
    this.setValue(this.value + addend);
    return this.digit < this.maxDigits;
};

Fitter.prototype.minus = function () {
    if (this.direction === UP) {
        this.log('+ -> -');
        this.digit = this.digit + 1;
    }
    let subtrahend = Math.pow(10, -1 * this.digit);
    if (this.numDuplicateSets > 1) {
        subtrahend *= 2;
    }
    this.log(`-${subtrahend}`);
    this.direction = DOWN;
    this.setValue(this.value - subtrahend);
    return this.digit < this.maxDigits;
};

Fitter.prototype.fitTo = function (compareFn, maxIterations) {
    let i = 0;
    maxIterations = maxIterations || this.maxIterations || 10000;
    while (i++ < maxIterations) {
        let comparisonResult = compareFn(this.value);
        if (comparisonResult === 0) {
            break;
        }
        let opResult;
        if (comparisonResult > 0) {
            opResult = this.minus();
        } else {
            opResult = this.plus();
        }
        if (opResult === false) {
            break;
        }
    }
    return this.value;
};

Fitter.prototype.fitPromiseIterator = function (compareFn, maxIterations) {
    let i = 0;
    maxIterations = maxIterations || 10000;
    return () => {
        if (i++ >= maxIterations) {
            return Promise.reject();
        }
        return new Promise((resolve, reject) => {
            let comparisonResult = compareFn(this.value);
            if (comparisonResult === 0) {
                reject(this.value);
                return;
            }

            let opResult;
            if (comparisonResult > 0) {
                opResult = this.minus();
            } else {
                opResult = this.plus();
            }
            if (opResult === false) {
                reject(this.value);
                return;
            }

            resolve(this.value);
        });
    };
};

module.exports = Fitter;

